import { CommonModule } from '@angular/common';
import { Component, HostBinding, input, output } from '@angular/core';
import type { FabMenuOptionId } from '@hunting-nature/shared-core/enums/tab-bar.enum';
import type { FabMenuOption, MenuConfig } from '@hunting-nature/shared-core/interfaces/tab-bar.interface';
import { IonIcon } from '@ionic/angular/standalone';
import { TranslocoPipe } from '@jsverse/transloco';

import { overlayAnimation } from './tab-bar-menu-overlay.animations';

@Component({
  selector: 'app-tab-bar-menu-overlay',
  templateUrl: './tab-bar-menu-overlay.component.html',
  styleUrls: ['./tab-bar-menu-overlay.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslocoPipe, IonIcon],
  animations: [overlayAnimation],
})
export class TabBarMenuOverlayComponent {
  @HostBinding('@overlayAnimation') animate = true;

  // inputs
  menuConfig = input.required<MenuConfig>();
  expandedOptionId = input<FabMenuOptionId | null>(null);

  // outputs
  backdropClick = output<void>();
  optionSelected = output<FabMenuOption>();
  collapseOption = output<void>();

  handleBackdropClick(): void {
    this.backdropClick.emit();
  }

  handleOptionClick(option: FabMenuOption, event: Event): void {
    event.stopPropagation(); // Prevent backdrop click
    this.optionSelected.emit(option);
  }

  handleCollapseOption(): void {
    this.collapseOption.emit();
  }
}
